// AppShell — top-level layout. Renders TopNav, page content, and the
// AppLevel error / loading states for the bootstrap path.
// The Principal-refresh probes (F-001) live in PrincipalContext; the
// AppShell composes the context provider in main.tsx.

import { Outlet } from 'react-router-dom';
import { TopNav } from './TopNav';
import { Spinner, ErrorBanner } from './primitives';
import { usePrincipalContext } from '@/auth/PrincipalContext';

export function AppShell() {
  const { principal, bootstrapping, bootstrapError } = usePrincipalContext();

  if (bootstrapping) {
    return (
      <div className="app-bootstrap">
        <a href="#main" className="skip-link">
          Skip to main content
        </a>
        <Spinner label="Loading" />
      </div>
    );
  }

  if (bootstrapError) {
    return (
      <div className="app-bootstrap-error">
        <a href="#main" className="skip-link">
          Skip to main content
        </a>
        <ErrorBanner
          message="Something went wrong loading the app."
          requestId={bootstrapError.requestId}
          onRetry={() => window.location.reload()}
          retryLabel="Reload"
        />
      </div>
    );
  }

  if (!principal) {
    // Should be unreachable: bootstrap-401 redirects in PrincipalContext.
    return (
      <div className="app-bootstrap-error">
        <ErrorBanner
          message="You're not signed in."
          onRetry={() => {
            window.location.href = '/v1/auth/login';
          }}
          retryLabel="Sign in"
        />
      </div>
    );
  }

  return (
    <div className="app-shell">
      <a href="#main" className="skip-link">
        Skip to main content
      </a>
      <TopNav />
      <main id="main" className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
